/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Modal_Titleminimum4Inputs */

const en_coinvestments_submitticketsize_modal_titleminimum4 = /** @type {(inputs: Coinvestments_Submitticketsize_Modal_Titleminimum4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. Ticket Size`)
};

/**
* | output |
* | --- |
* | "Min. Ticket Size" |
*
* @param {Coinvestments_Submitticketsize_Modal_Titleminimum4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_modal_titleminimum4 = /** @type {((inputs?: Coinvestments_Submitticketsize_Modal_Titleminimum4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Modal_Titleminimum4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_modal_titleminimum4(inputs)
});
export { coinvestments_submitticketsize_modal_titleminimum4 as "coInvestments_submitTicketSize_modal_titleMinimum" }